const { LoginError, OTP_RETRY_TIME_IN_MINUTES } = require('./constant');

function LoginErrorController() {
    if (this.error === LoginError.TOO_MANY_VERIFICATION_ATTEMPTS) {
        this.errorHeading = 'Number of verification attempts exceeded';
        this.errorMessage = `You have exceeded the number of verification attempts allowed. Please try again in ${OTP_RETRY_TIME_IN_MINUTES} minutes.`;
    } else if (this.error === LoginError.TOO_MANY_CODE_GENERATION_ATTEMPTS) {
        this.errorHeading = 'Number of code generation attempts exceeded';
        this.errorMessage = `You have exceeded the number of code generation requests allowed. You can request another code in ${OTP_RETRY_TIME_IN_MINUTES} minutes.`;
    } else if (this.error === LoginError.VERIFICATION_SERVER_ERROR) {
        this.errorHeading = 'Something went wrong';
        this.errorMessage = `Sorry, we weren't able to verify the code. Please try again.`;
    }
}

function loginErrorDirectiveFactory() {
    return {
        restrict: 'E',
        scope: {
            error: '@'
        },
        controller: ['$scope', LoginErrorController],
        controllerAs: 'ctrl',
        bindToController: true,
        template: require('./login-error-template.html').trim()
    };
}

module.exports = {
    DirectiveController: LoginErrorController,
    directiveFactory: loginErrorDirectiveFactory
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/login-error-directive.js
 **/